import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { nanoid } from "nanoid";
import style from "./style.module.scss";
export default function Switch(props) {
    const id = props.id || nanoid(10);
    return (_jsxs("div", { className: style["switch"], children: [_jsx("input", Object.assign({ type: "checkbox" }, props, { checked: props.checked, id: id })), _jsx("label", { className: classNames(style["switch__display"], { [style["checked"]]: props.checked }), htmlFor: id, children: _jsx("span", { className: classNames(style["slider"], style["round"], "qa-slider") }) })] }));
}
